import { StoreInterface } from 'src/store'
import { ELibraryStateInterface } from 'src/store/eLibrary/state'
import { ActionContext, ActionTree } from 'vuex'

const actions: ActionTree<ELibraryStateInterface, StoreInterface> = {
  setTotalStorageUsed ({ commit }: ActionContext<ELibraryStateInterface, StoreInterface>, totalStorageUsed: number): void {
    commit('setTotalStorageUsed', totalStorageUsed)
  }
}

export default actions
